module.exports = __webpack_public_path__ + "static/media/10_avatar.f08ace6c.png";